
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'StaticPage',
  components: {
    VueEasyLightbox
  },
  data() {
    return {
      images_1: [
          { src: '/static/images/help/zh/network/image_4.png', alt: '' },
          { src: '/static/images/help/zh/network/image_5.png', alt: '' },
          { src: '/static/images/help/zh/network/image_6.png', alt: '' },
          { src: '/static/images/help/zh/network/image_7.png', alt: '' },
          { src: '/static/images/help/zh/network/image_8.png', alt: '' },
          { src: '/static/images/help/zh/network/image_9.png', alt: '' }
        ],
      images_2: [
          { src: '/static/images/help/zh/network/image_10.png', alt: '图片 9' },
          { src: '/static/images/help/zh/network/image_11.png', alt: '图片 10' },
          { src: '/static/images/help/zh/network/image_12.png', alt: '图片 11' },
          { src: '/static/images/help/zh/network/image_13.png', alt: '图片 12' },
          { src: '/static/images/help/zh/network/image_14.png', alt: '图片 13' }
        ],
      images_3: [
          { src: '/static/images/help/zh/network/image_15.png', alt: '图片 15' },
          { src: '/static/images/help/zh/network/image_16.png', alt: '图片 16' },
          { src: '/static/images/help/zh/network/image_17.png', alt: '图片 17' },
          { src: '/static/images/help/zh/network/image_18.png', alt: '图片 18' },
          { src: '/static/images/help/zh/network/image_19.png', alt: '图片 19' },
          { src: '/static/images/help/zh/network/image_20.png', alt: '图片 20' }
        ],
      images_4: [
          { src: '/static/images/help/zh/network/image_21.png', alt: '图片 22' },
          { src: '/static/images/help/zh/network/image_22.png', alt: '图片 23' },
          { src: '/static/images/help/zh/network/image_23.png', alt: '图片 24' }
        ],
      images_5: [
          { src: '/static/images/help/zh/network/image_24.png', alt: '图片 26' },
          { src: '/static/images/help/zh/network/image_25.png', alt: '图片 27' },
          { src: '/static/images/help/zh/network/image_26.png', alt: '图片 28' },
          { src: '/static/images/help/zh/network/image_27.png', alt: '图片 29' },
          { src: '/static/images/help/zh/network/image_28.png', alt: '图片 30' },
          { src: '/static/images/help/zh/network/image_29.png', alt: '图片 31' }
        ],
      images_6: [
          { src: '/static/images/help/zh/standalone/image_1.png', alt: '图片 26' },
          { src: '/static/images/help/zh/standalone/image_2.png', alt: '图片 27' },
          { src: '/static/images/help/zh/standalone/image_3.png', alt: '图片 28' },
          { src: '/static/images/help/zh/standalone/image_4.png', alt: '图片 29' },
          { src: '/static/images/help/zh/standalone/image_5.png', alt: '图片 30' },
        ],
      images_en_1: [
        { src: '/static/images/help/en/network/image_4_en.png', alt: '图片 2' },
        { src: '/static/images/help/en/network/image_5_en.png', alt: '图片 3' },
        { src: '/static/images/help/en/network/image_6_en.png', alt: '图片 4' },
        { src: '/static/images/help/en/network/image_7_en.png', alt: '图片 5' }
      ],
      images_en_3: [
        { src: '/static/images/help/en/network/image_8_en.png', alt: '图片 6' },
        { src: '/static/images/help/en/network/image_9_en.png', alt: '图片 7' },
        { src: '/static/images/help/en/network/image_10_en.png', alt: '图片 8' },
        { src: '/static/images/help/en/network/image_11_en.png', alt: '图片 9' }
      ],
      images_en_4: [
        { src: '/static/images/help/en/network/image_12_en.png', alt: '图片 10' },
        { src: '/static/images/help/en/network/image_13_en.png', alt: '图片 11' },
        { src: '/static/images/help/en/network/image_14_en.png', alt: '图片 12' },
        { src: '/static/images/help/en/network/image_15_en.png', alt: '图片 13' },
        { src: '/static/images/help/en/network/image_16_en.png', alt: '图片 14' }
      ],
      images_en_5: [
        { src: '/static/images/help/en/network/image_17_en.png', alt: '图片 15' },
        { src: '/static/images/help/en/network/image_18_en.png', alt: '图片 16' },
        { src: '/static/images/help/en/network/image_19_en.png', alt: '图片 17' },
        { src: '/static/images/help/en/network/image_20_en.png', alt: '图片 18' },
        { src: '/static/images/help/en/network/image_21_en.png', alt: '图片 19' },
        { src: '/static/images/help/en/network/image_22_en.png', alt: '图片 20' }
      ],
      images_en_6: [
        { src: '/static/images/help/en/standalone/image_en_1.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_2.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_3.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_4.png', alt: '' },
        { src: '/static/images/help/en/standalone/image_en_5.png', alt: '' },
      ],
      previewVisible: false,
      previewImages: [],
      previewIndex: 0,
      lang:'',
      activeName:'a',
      imageCount: 12,
      typeParam: null // 控制显示的 type 参数

    }
  },
  computed: {
    images_7() {
      return this.generateImageList('zh')
    },
    images_en_7() {
      return this.generateImageList('en')
    },
  },
  mounted() {
    this.lang=this.$route.query.lang?this.$route.query.lang:'zh'
    this.$i18n.locale = this.lang
    this.checkUrlParams()
  },
  methods: {
    generateImageList(lang) {
      const images = []
      if(lang==='en'){
         for (let i = 1; i <= this.imageCount; i++) {
            images.push({
              src: `/static/images/help/${lang}/phone/image_en_${i}.png`, // 根据实际路径调整
              alt: `Image ${i}`,
            })
          }
          return images
      }else {
         for (let i = 1; i <= this.imageCount; i++) {
            images.push({
              src: `/static/images/help/${lang}/phone/image_${i}.png`, // 根据实际路径调整
              alt: `Image ${i}`,
            })
          }
          return images
      }
     },
    title() {
        switch (this.activeName) {
          case 'a':
            return this.$t('append_field.network_import')
          case 'b':
            return this.$t('append_field.mobile_mode')
           case 'c':
             return this.$t('append_field.standalone_mode')
        }
      },
    openPreview(images, index) {
        this.previewImages = images.map(image => image.src)
        this.previewIndex = index
        this.previewVisible = true

      },
    closePreview() {
        this.previewVisible = false
      },
    checkUrlParams() {
      this.typeParam =  this.$route.query.type?this.$route.query.type:''
      if (this.typeParam === 'mobile') {
        this.activeName = 'b' // 当 type=mobile 时，默认激活 tab b
      }
    },
    shouldShowTab(tabName) {
      if (this.typeParam === 'mobile') {
        return tabName === 'b' // 仅显示 tab b
      }
      return true // 显示所有标签页
    },
    /*
    * 切换tab时滚动到顶部
    * */
    onTabChange(name) {

      this.$nextTick(() => {
        let pageContainer
        if (name === 'b') {
          pageContainer = this.$refs.pageContainerB
        } else if (name === 'c') {
          pageContainer = this.$refs.pageContainerC
        }else {
          pageContainer = this.$refs.pageContainerA
        }
        if (pageContainer) {
           pageContainer.scrollTop = 0
        }
      })
    }
  },

}
